import { render, staticRenderFns } from "./orderPlaced.vue?vue&type=template&id=4832b628&scoped=true"
import script from "./orderPlaced.vue?vue&type=script&lang=js"
export * from "./orderPlaced.vue?vue&type=script&lang=js"
import style0 from "./orderPlaced.vue?vue&type=style&index=0&id=4832b628&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4832b628",
  null
  
)

export default component.exports